module.exports = __webpack_public_path__ + "img/challenge_result_2.322e78cb.png";